import { render, staticRenderFns } from "./SingleEvent.vue?vue&type=template&id=7af81c8b&scoped=true&"
import script from "./SingleEvent.vue?vue&type=script&lang=js&"
export * from "./SingleEvent.vue?vue&type=script&lang=js&"
import style0 from "./SingleEvent.vue?vue&type=style&index=0&id=7af81c8b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af81c8b",
  null
  
)

export default component.exports